import { createSlice } from "@reduxjs/toolkit";

const initialToken = localStorage.getItem('token');
const initialUsername = localStorage.getItem('username');
const initialPrivilegios = localStorage.getItem('privilegios');


const initialAuthState = { isAuth: !!initialToken, token: initialToken, 
    username: initialUsername, privilegios: JSON.parse(initialPrivilegios)};

const authSlice = createSlice({
    name: 'authentication',
    initialState: initialAuthState,
    reducers: {
        logout(state){
            state.isAuth = false;
            state.username = ''; 
            state.token = '';
            state.privilegios = [];
            localStorage.removeItem('token');
            localStorage.removeItem('username');
            localStorage.removeItem('privilegios');
        },
        login(state, action){
            state.token = action.payload.token;
            state.username = action.payload.username;
            state.privilegios = action.payload.privilegios;
            state.isAuth = true;
            localStorage.setItem('token', state.token);
            localStorage.setItem('username', state.username);
            localStorage.setItem('privilegios', JSON.stringify(state.privilegios));
        }
    }
});

export const authActions = authSlice.actions;

export default authSlice.reducer;